function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLondon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 64.800781 28.441406 L 78.570312 28.441406 L 78.570312 23.851562 L 64.800781 23.851562 Z M 61.46875 42.480469 L 28.171875 42.480469 L 28.171875 66.691406 L 61.46875 66.691406 Z M 28.171875 34.199219 L 61.46875 34.199219 L 61.46875 28.261719 L 60.210938 28.261719 L 60.210938 19.980469 L 61.378906 18 L 62.460938 16.019531 L 63.628906 18 L 64.800781 19.980469 L 64.800781 20.519531 L 67.230469 16.289062 L 71.640625 8.730469 L 75.960938 16.289062 L 78.570312 20.699219 L 78.570312 19.980469 L 79.738281 18 L 80.820312 16.019531 L 81.988281 18 L 83.160156 19.980469 L 83.160156 28.261719 L 81.449219 28.261719 L 81.449219 68.039062 L 87.03125 68.039062 L 87.03125 81.269531 L 56.789062 81.269531 L 56.789062 72.808594 C 48.960938 70.738281 41.128906 70.46875 33.210938 72.539062 L 33.210938 81.269531 L 2.96875 81.269531 L 2.96875 68.039062 L 8.28125 68.039062 L 8.28125 28.261719 L 7.019531 28.261719 L 7.019531 19.980469 L 8.101562 18 L 9.269531 16.019531 L 10.441406 18 L 11.519531 19.980469 L 11.519531 20.519531 L 14.039062 16.289062 L 18.359375 8.730469 L 22.769531 16.289062 L 25.378906 20.699219 L 25.378906 19.980469 L 26.460938 18 L 27.628906 16.019531 L 28.800781 18 L 29.878906 19.980469 L 29.878906 28.261719 L 28.171875 28.261719 Z M 11.519531 28.441406 L 25.378906 28.441406 L 25.378906 23.851562 L 11.519531 23.851562 Z M 11.519531 28.441406 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLondon);
export default __webpack_public_path__ + "static/media/london.18b10d02e9b06bfb5855f18bc1f73d34.svg";
export { ForwardRef as ReactComponent };